import * as React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@avensia/excite';
import { yellow } from 'svenssons/shared/theme';

type Props = {
  storeAvailability?: NordicNest.Api.StoreAvailability;
};

const Status = React.memo(({ storeAvailability }: Props) => {
  if (storeAvailability === 'instock') {
    return <Green />;
  }

  if (storeAvailability === 'productHasDemoStock' || storeAvailability === 'variantDemoStock') {
    return <Yellow />;
  }

  return <Gray />;
});

const Bullet = styled(
  () => (
    <styled.Svg width="7" height="7" viewBox="0 0 7 7">
      <circle cx="3.5" cy="3.5" r="3.5" fill="currentColor" />
    </styled.Svg>
  ),
  {
    marginRight: t => t.sharedSpacing.xs,
    flexShrink: 0,
  },
);

const Green = styled(Bullet, {
  color: t => t.positive.color,
});

const Yellow = styled(Bullet, {
  color: yellow,
});

const Gray = styled(Bullet, {
  color: t => t.monochrome.color,
});

export const getStoreAvailabilityTranslation = (key?: NordicNest.Api.StoreAvailability) => {
  switch (key) {
    case 'instock':
      return translate(t => t.store.inStock);
    case 'productHasDemoStock':
      return translate(t => t.store.productHasDemoStock);
    case 'variantDemoStock':
      return translate(t => t.store.variantDemoStock);
    case 'outOfStock':
      return translate(t => t.store.outOfStock);
    default:
      return translate(t => t.store.unknownStockStatus);
  }
};

export const StoreAvailability = styled(
  React.memo(({ storeAvailability }: Props) => {
    const message: string[] = [getStoreAvailabilityTranslation(storeAvailability)];

    return (
      <Base>
        <Status storeAvailability={storeAvailability} />
        <Message> {message}</Message>
      </Base>
    );
  }),
);

const Base = styled.div({
  fontSize: t => t.sharedFontSize.xxs,
  color: t => t.dark.color,
  display: 'flex',
  alignItems: 'center',
});

const Message = styled.div({
  display: 'flex',
  alignItems: 'baseline',
  margin: {
    bottom: t => t.sharedSpacing.l,
  },
  ':last-child': {
    margin: {
      bottom: 0,
    },
  },
});
